import React from 'react'
import { Navbar as BSNavbar } from 'react-bootstrap'
import styled from 'styled-components'

const SubNavbarContainer = styled(BSNavbar)`
  height: 48px;
  background-color: white;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.075);
  margin-top: 75px;
  z-index: 2;
  padding: 0px !important;
  display: flex;
  justify-content: space-between;
`

const SubNavbar: React.FC = ({ children }) => {
  return <SubNavbarContainer fixed="top">{children}</SubNavbarContainer>
}

export default SubNavbar
